import * as React from "react";
import { ConstBreakPoint } from "src/config/styles_const/styles_const";
import { IProjectRepository } from "src/domain/repository/project_repository";
import { createApiClient, IApiClient } from "src/infra/api/client";
import { createProjectAPI } from "src/infra/api/service/project_api";
import GoldLink from "src/presentation/common/atom/btn/gold_link";
import styled from "styled-components";
import { Company } from "../../../../domain/model/company";
import { Project } from "../../../../domain/model/project";
import Pagination from "../../../common/molecular/pagination/pagination";
import ProjectClientCard from "../../../common/organism/card/project_client_card";
import { TPagination } from "../../../type/common";

interface IProps {
  projects: Project[];
  companies: Company[];
  paginationPrams: TPagination;
  onCopy: (id: string) => void;
}

const apiClient: IApiClient = createApiClient();
const projectRepository: IProjectRepository = createProjectAPI(apiClient);

export const ClientProjectsMain: React.FC<IProps> = (props) => {
  const { projects, paginationPrams, onCopy } = props;
  // const [_projects, setProjects] = React.useState<Project[]>(projects);

  return (
    <React.Fragment>
      <div style={{ display: "flex", flexDirection: "row-reverse" }}>
        <AddLink to={`/client/project/create/new`}>案件を作成する</AddLink>
      </div>
      {projects.map((project: Project, index: number) => {
        const projectId: string = project.id;
        return (
          <ProjectCardWrapper key={projectId}>
            <ProjectClientCard project={project} onCopy={onCopy} />
          </ProjectCardWrapper>
        );
      })}
      <Pagination paginationPrams={paginationPrams} />
    </React.Fragment>
  );
};

export default ClientProjectsMain;

const ProjectCardWrapper = styled.div`
  margin-bottom: 0px;
`;

const AddLink = styled(GoldLink)`
  width: 155px;
  margin-top: 10px;
  display: block;
  font-size: 12px;
  text-align: center;
  @media screen and (min-width: ${ConstBreakPoint.PcDeskTop}) {
    margin-top: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/projects/client_projects_main.tsx